import React, { Component } from 'react';
import {
  Section,
  Title,
  Body,
  SectionGrid,
} from './Section';
// icons
import IconTime from 'react-icons/lib/md/access-time';
import IconFace from 'react-icons/lib/md/face';
import IconNotify from 'react-icons/lib/md/notifications-active';
import IconCloud from 'react-icons/lib/md/cloud-done';
import IconLogs from 'react-icons/lib/fa/list';
import IconExtensions from 'react-icons/lib/md/extension';

import './Landing.css';

class PowerfulFeatures extends Component {
  render() {
    return (
      <Section sStyle="yellow">
        <Title title="POWERFUL" subtitle="FEATURES!" />
        <Body>
          We are constantly working on adding more features to improve our service.
          We'd love to hear your feedbacks and suggestions!
        </Body>
        <SectionGrid items={[
          {
            icon: <IconTime />,
            text: "Real-time control over your intercom from anywhere at anytime"
          },
          {
            icon: <IconFace />,
            text: "Unlimited passcodes for all your family, friends, and guests"
          },
          {
            icon: <IconNotify />,
            text: "Instant text notifications for your intercom's activities"
          },
          {
            icon: <IconCloud />,
            text: "Highly realiabile and secure service built with Amazon AWS and Google Cloud"
          },
          {
            icon: <IconLogs />,
            text: "Detail activity logs to keep track of access history"
          },
          {
            icon: <IconExtensions />,
            text: "Enhanced capabilities and customizations with add-ons"
          },
        ]} />
      </Section>
    );
  }
}

export default PowerfulFeatures


// WEBPACK FOOTER //
// ./src/entries/Static/PowerfulFeatures.js